export const SHOW_CURATION = 'show-curation';
const showCuration = () => ({ type: SHOW_CURATION });
export default showCuration;
